import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../Context/AuthContext";

const useAxiosFetch = () => {
  const [response, setResponse] = useState([]);
  const [error, setError] = useState("");
  const [axiosLoading, setAxiosLoading] = useState(false); //different!
  const [controller, setController] = useState();
  const route = useNavigate();
  const { Logout } = useAuth();

  const axiosFetch = async (configObj) => {
    const { axiosInstance, method, navigatesUrl, stateUpdateFunction, url, requestConfig = {} } = configObj;



    const promise = new Promise(async (resolve, reject) => {
      try {
        setAxiosLoading(true);
        const ctrl = new AbortController();
        setController(ctrl);
        const res = await axiosInstance[method.toLowerCase()](url, {
          ...requestConfig,
          signal: ctrl.signal,
        });
        setResponse(res.data);
        if (res?.data?.errMsg) {

        } else {
          if (stateUpdateFunction) {

            stateUpdateFunction(res.data)
          }
          if (navigatesUrl) {
            route(navigatesUrl)
          }
        }



        resolve(res)


      } catch (err) {

        if (err?.response?.data.status) {
          Logout()
        }
        setError(err.message);
        reject(err)
      } finally {
        setAxiosLoading(false);
      }
    });

    return promise

  };

  useEffect(() => {
    // useEffect cleanup function
    return () => controller && controller.abort();
  }, [controller]);

  return {response, error, axiosLoading, axiosFetch};
};

export default useAxiosFetch;
